// import React from 'react'
// import Select from 'react-select';

// const Test = ({L1,L2,L3,ME,MG}) => {
//   return (
//   )
// }

// export default Test

export const options = {
  L1 : [
      { value: 'Algèbre 2', label: 'Algèbre 2' },
      { value: 'Analyse 2', label: 'Analyse 2' },
      { value: 'Calcul numérique 1', label: 'Calcul numérique 1' },
      { value: 'Optique géométrique', label: 'Optique géométrique' },
      { value: 'Magnétostatique et régimes variables', label: 'Magnétostatique et régimes variables' },
      { value: 'Langage C', label: 'Langage C' },
      { value: 'Introduction à la programmation', label: 'Introduction à la programmation' },
      { value: 'Architecture des ordinateurs 2', label: 'Architecture des ordinateurs 2' },
      { value: 'Anglais', label: 'Anglais' },
  ],
  L2 : [
      { value: 'GRH', label: 'GRH' },
      { value: 'Fiscalité', label: 'Fiscalité' },
      { value: 'Marketing -E-Marketing', label: 'Marketing -E-Marketing' },
      { value: 'Comptabilité de Gestion', label: 'Comptabilité de Gestion' },
      { value: 'Croissance et fluctuation', label: 'Croissance et fluctuation' },
      { value: 'Méthodes quantitatives', label: 'Méthodes quantitatives' },
      { value: 'Economie du développement', label: 'Economie du développement' },
  ],
  M2 : [
      { value: 'Politiques Publiques Urbaines', label: 'Politiques Publiques Urbaines' },
  ],
  L3 : [
      { value: ' Mathématiques financière', label: ' Mathématiques financière' },
      { value: 'Méthode proba de la finance', label: 'Méthode proba de la finance' },
      { value: 'Système d\'information', label: 'Système d\'information' },
      { value: 'Gestion de base de données', label: 'Gestion de base de données' },
      { value: 'Analyse financière', label: 'Analyse financière' },
      { value: ' Contrôle de gestion', label: ' Contrôle de gestion' },
      { value: ' Comptabilité approfondie', label: ' Comptabilité approfondie' },
      { value: 'Gestion budgétaire', label: 'Gestion budgétaire' },
      { value: 'Finance de marché', label: 'Finance de marché' },
      { value: ' Finance d\'entreprise', label: ' Finance d\'entreprise' },
      { value: 'Econométrie', label: 'Econométrie' },
  ],
  ME : [
      { value: 'Commerce international', label: 'Commerce international' },
      { value: 'Marchés financiers', label: 'Marchés financiers' },
      { value: 'Economie de l\'environnement', label: 'Economie de l\'environnement' },
      { value: 'Théories des contrats et incitations', label: 'Théories des contrats et incitations' },
      { value: 'Epistémologie', label: 'Epistémologie' },
      { value: 'Econométrie appliquée', label: 'Econométrie appliquée' },
      { value: 'Finance internationale', label: 'Finance internationale' },
      { value: 'Evaluation d’impact', label: 'Evaluation d’impact' },
      { value: 'Croissance et fluctuations', label: 'Croissance et fluctuations' },
      { value: 'Modélisation économique', label: 'Modélisation économique' },
      { value: 'Macroéconomie approfondie', label: 'Macroéconomie approfondie' },
      { value: 'Economie publique', label: 'Economie publique' },
      { value: 'Economie de l\'incertain', label: 'Economie de l\'incertain' },
      { value: 'Analyse risque pays', label: 'Analyse risque pays' },
      { value: 'Economie de l\'environnement et des ressources naturelles', label: 'Economie de l\'environnement et des ressources naturelles' },
      { value: 'Financement du développement', label: 'Financement du développement' },
      { value: 'Economie du changement climatique', label: 'Economie du changement climatique' },
      { value: 'Croissance durable', label: 'Croissance durable' },
      { value: 'Finance durable', label: 'Finance durable' },
      { value: 'Comptabilité écologique', label: 'Comptabilité écologique' },
      { value: 'Géopolitique des ressources naturelles', label: 'Géopolitique des ressources naturelles' },
      { value: "Management de l\'environnement et responsabilitésociétale des entreprises", label: "Management de l\'environnement et responsabilitésociétale des entreprises" },
      { value: 'Modélisation en équilibre général calculable', label: 'Modélisation en équilibre général calculable' },
      { value: 'Econométrie des données de panel/Données qualitatives', label: 'Econométrie des données de panel/Données qualitatives' },
  ],
  MG : [
      { value: 'Fiscalité des groupes', label: 'Fiscalité des groupes' },
      { value: 'Consolidation', label: 'Consolidation' },
      { value: 'Marché des matières premières et marché d\'échanges', label: 'Marché des matières premières et marché d\'échanges' },
      { value: 'Ingénierie et stratégie financière', label: 'Ingénierie et stratégie financière' },
      { value: 'Communication d\'entreprise', label: 'Communication d\'entreprise' },
      { value: 'Management stratégique', label: 'Management stratégique' },
      { value: 'Marketing stratégique', label: 'Marketing stratégique' },
      { value: 'Conduite du changement', label: 'Conduite du changement' },
      { value: 'Marketing bancaire', label: 'Marketing bancaire' },
      { value: 'Marché financier et gestion de portefeuille', label: 'Marché financier et gestion de portefeuille' },
      { value: 'Méthodes quantitatives', label: 'Méthodes quantitatives' },
      { value: 'Méthodes Modélisation financière', label: 'Méthodes quantitatives' },
      { value: 'Normes internationales (IFRS)', label: 'Normes internationales (IFRS)' },
      { value: 'Diagnostic financier', label: 'Diagnostic financier' },
  ],
}
// export function YourComponent() {
//   const handleChange = selectedOptions => {
//     // Faites quelque chose avec les options sélectionnées
//     console.log('Options sélectionnées :', selectedOptions);
//   };

//   return (
//     <Select
//       isMulti
//       name='matiere1'
//       options={options}
//       onChange={handleChange}
//       placeholder='--- Sélectionner ---'
//     />
//   );
// }


